import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-y', 'LetterY', [["path",{"d":"m8 7 3.75 5m3.75-5-3.75 5m0 0v5","key":"svg-0"}]]);